/**
 * Locale-aware path helpers — app-facing wrappers.
 *
 * Binds the app's locale-config (isLocaleSegment + DEFAULT_LOCALE) to the pure,
 * parameterized engine from @scrawlr/lib-js-i18n and re-exports the original
 * zero-config signatures, so every call site is unchanged.
 */
import {
    DEFAULT_LOCALE,
    isLocaleSegment,
} from '../data/static/locale-config.js'
import { createLocalePath } from '@scrawlr/lib-js-i18n'

const localePath = createLocalePath({
    defaultLocale: DEFAULT_LOCALE,
    isLocaleSegment,
})

export const {
    buildPathnameForLocale,
    getLocaleFromPathname,
    getPathWithoutLocalePrefix,
    pathnameHasLocalePrefix,
} = localePath


export {
    getFirstPathSegment,
    searchHashSuffix,
} from '@scrawlr/lib-js-i18n'
